(function() {
    let menu = document.querySelector('.header');

    if (!menu) {
        return;
    }

    let previousPositionY = window.pageYOffset;

    menu.style.position = 'fixed';
    menu.style.width = '100%';
    menu.style.top = '0px';

    let raf = window.requestAnimationFrame || false;

    if (raf) {
        loop();
    }

    function loop() {
        if (previousPositionY === window.pageYOffset) {
            raf(loop);

            return;
        }

        scroll();

        raf(loop);
    }

    function scroll() {
        let menuHeight = menu.clientHeight;
        let menuTopSide = menu.offsetTop;
        let menuBottomSide = menu.offsetTop + menuHeight;
        let currentPositionY = window.pageYOffset;

        if (previousPositionY >= currentPositionY || currentPositionY <= 0) {
            if (currentPositionY <= menuTopSide) {
                menu.style.position = 'fixed';
                menu.style.top = '0';
            }
        } else {
            if (menu.style.position === 'fixed') {
                let menuTop = currentPositionY < 0 ? 0 : currentPositionY;

                menu.style.position = 'absolute';
                menu.style.top = `${menuTop}px`;
            } else {
                let pageSize = getPageSize();
                if (pageSize.height > currentPositionY + document.documentElement.clientHeight) {
                    if (currentPositionY >= menuBottomSide) {
                        menu.style.top = `${currentPositionY - menuHeight}px`;
                    }
                }
            }
        }

        previousPositionY = window.pageYOffset;
    }

    menu.addEventListener('click', (e) => {
        if (menu.style.position === 'fixed') {
            return;
        }

        document.documentElement.scrollTo({ top: menu.offsetTop, left: 0, behavior: 'smooth' });
    });

    function getPageSize() {
        return document.documentElement.getBoundingClientRect();
    }
})();

